import React from 'react';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import CircleOutline from 'material-ui/svg-icons/content/add-circle-outline';
import Select from 'react-select';
import R from 'ramda';

const CancellationRules = ({
  cancelNum,
  cancelHoursDays,
  conditions,
  additionalRules,
  onChange,
  showError,
}) => {
  const updateInAdditionalRules = (ruleIndex, key, value) => {
    const updatedRules = additionalRules.map((thisRule, thisIndex) => thisIndex === ruleIndex ? ({
      ...thisRule,
      [key]: value,
    }) : thisRule);
    return onChange('additionalRules', updatedRules);
  };
  return (
    <div>
      <div style={{ marginTop: '16px', fontWeight: 'bold', fontSize: '13px' }}>
        Basic Cancellation Rule:
        <small style={{ color: 'red', fontWeight: showError ? 'bold' : 'initial', fontSize: showError ? '14px' : '10px' }}>
          &nbsp;{showError ? 'Missing Information' : '* All fields required'}
        </small>
      </div>
        <div style={{ fontSize: '13px' }}>
          Cancel at least
          <TypeControlledTextField
            id={`cancelNum`}
            hintText="Number"
            controlledType="number"
            hintStyle={{ fontSize: '13px' }}
            inputStyle={{ fontSize: '13px', marginTop: '0', textAlign: 'right' }}
            style={{ width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' }}
            errorStyle={{ fontSize: '10px' }}
            underlineStyle={{ bottom: '10px' }}
            value={cancelNum || ''}
            onChange={({ target: { value } }) => onChange('cancelNum', value)}
          />
          <div style={{ marginLeft: '10px', marginRight: '5px', width: '95px', display: 'inline-block', position: 'relative', top: '12px' }}>
            <Select
              name="cancelHoursDays"
              options={[
                { value: 'hours', label: 'Hours' },
                { value: 'days', label: 'Days' },
              ]}
              value={cancelHoursDays}
              onChange={({ value }) => onChange('cancelHoursDays', value)}
              placeholder="Hours/Days"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
          prior to the date of travel to avoid any cancellation fees.
        </div>
        {
          additionalRules && additionalRules.length ? (<div style={{ marginTop: '16px', fontWeight: 'bold', fontSize: '12px' }}>Additional Cancellation Rules</div>) : <div/>
        }
        {
          additionalRules ? additionalRules.map((rule, ruleIndex) => (
            <div key={ruleIndex} style={{ marginBottom: '16px', fontSize: '12px' }}>
              {ruleIndex + 1}. If cancelled within
              <TypeControlledTextField
                id={`${ruleIndex}cancelNum`}
                hintText="Number"
                controlledType="number"
                hintStyle={{ fontSize: '12px' }}
                inputStyle={{ fontSize: '14px', marginTop: '0', textAlign: 'right' }}
                style={{ width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' }}
                errorStyle={{ fontSize: '10px' }}
                underlineStyle={{ bottom: '10px' }}
                value={rule.cancelNum || ''}
                onChange={({ target: { value } }) => updateInAdditionalRules(ruleIndex, 'cancelNum', value)}
              />
              <div style={{ marginLeft: '10px', marginRight: '5px', width: '95px', display: 'inline-block', position: 'relative', top: '12px' }}>
                <Select
                  name="cancelHoursDays"
                  options={[
                    { value: 'hours', label: 'hours' },
                    { value: 'days', label: 'days' },
                  ]}
                  value={rule.cancelHoursDays}
                  onChange={({ value }) => updateInAdditionalRules(ruleIndex, 'cancelHoursDays', value)}
                  placeholder="hours/days"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
              of the date of
              <div style={{ marginLeft: '10px', marginRight: '5px', width: '135px', display: 'inline-block', position: 'relative', top: '12px' }}>
                <Select
                  name="arrivalDeparture"
                  options={[
                    { value: 'arrival', label: 'arrival' },
                    { value: 'departure', label: 'departure' },
                  ]}
                  value={rule.arrivalDeparture}
                  onChange={({ value }) => updateInAdditionalRules(ruleIndex, 'arrivalDeparture', value)}
                  placeholder="arrival/departure"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
              , a fee equivalent to
              <TypeControlledTextField
                id={`${ruleIndex}cancelFee`}
                hintText="Number"
                controlledType="number"
                hintStyle={{ fontSize: '12px' }}
                inputStyle={{ fontSize: '14px', marginTop: '0', textAlign: 'right' }}
                style={{ width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' }}
                errorStyle={{ fontSize: '10px' }}
                underlineStyle={{ bottom: '10px' }}
                value={rule.cancelFee || ''}
                onChange={({ target: { value } }) => updateInAdditionalRules(ruleIndex, 'cancelFee', value)}
              />
              <div style={{ marginLeft: '10px', marginRight: '5px', width: '220px', display: 'inline-block', position: 'relative', top: '12px' }}>
                <Select
                  name="dollarPercent"
                  options={[
                    { value: '(in the booking currency)', label: '(in the booking currency)' },
                    { value: 'percent', label: 'percent' },
                  ]}
                  value={rule.feeDollarPercent}
                  onChange={({ value }) => updateInAdditionalRules(ruleIndex, 'feeDollarPercent', value)}
                  placeholder="amount/percent"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
              <div style={{ width: '250px', marginLeft: '5px', display: rule.feeDollarPercent === 'percent' ? 'inline-block' : 'none', position: 'relative', top: '12px' }}>
                <Select
                  name={`${ruleIndex}feeBase`}
                  options={[
                    { value: 'of the cost of the first night', label: 'of the cost of the first night' },
                    { value: 'of the cost of the last night', label: 'of the cost of the last night' },
                    { value: 'of the average cost of a night during the stay', label: 'of the average cost of a night during the stay' },
                    { value: 'of the total value of the booking', label: 'of the total value of the booking' },
                    { value: 'of the minimum night stay for the rate booked', label: 'of the minimum night stay for the rate booked' },
                  ]}
                  value={rule.feeBase}
                  onChange={({ value }) => updateInAdditionalRules(ruleIndex, 'feeBase', value)}
                  placeholder="Click to select..."
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>&nbsp;
              will be charged.
              <span
                className="hint--top"
                aria-label="Remove this rule"
                style={{ cursor: 'pointer', position: 'relative', top: '6px', marginLeft: '52px' }}
                onClick={() => onChange('additionalRules', additionalRules.filter((_, thisIndex) => thisIndex !== ruleIndex))}
              >
                <CircleOutline style={{ color: 'red', transform: 'rotate(45deg)' }} />
              </span>
            </div>
          )) : <div/>
        }
        <div style={{ margin: '12px 0' }}>
           <AddItemCard editable text="Add another cancellation rule" onClick={() => onChange('additionalRules', R.append({}, additionalRules))}/>
           </div>
        <div style={{ marginTop: '8px', fontWeight: 'bold', fontSize: '13px' }}>
          Other condition:
          <small style={{ color: 'red', fontWeight: showError ? 'bold' : 'initial', fontSize: showError ? '14px' : '10px' }}>
          &nbsp;{showError ? 'Missing Information' : '* Required'}
          </small>
        </div>
        <small>Please enter NA if not applicable</small>
        <textarea
          rows={2}
          style={{ fontSize: '13px', margin: '8px 0' }}
          placeholder="Please enter other conditions here..."
          value={conditions || ''}
          autoFocus
          onChange={({ target: { value } }) => onChange('conditions', value)}
        />
    </div>);
};

export default CancellationRules;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/seasonal-cancellation-policy/rules.jsx